<template>
    <div>
        <b-card :header="uLang('app.entity_details', { entity: lang('app.action_document') })" header-tag="h4" class="bg-default-card" v-if="action_document">
            <div class="row">
                <div class="col-md-12">
                    <div class="inner">
                        <div class="mb-3 clearfix">
                            <router-link class="btn btn-brand" :to="{ name: 'admin.action-documents.edit', params: { id: this.id } }">{{ uLang('app.edit_type', { type: lang('app.action_document') }) }}</router-link>
                            <button
                                type="button"
                                @click="showDocument = true"
                                class="btn btn-brand"
                            >{{ uLang('app.see_pdf') }}</button>
                        </div>

                        <portal to="modals" v-if="showDocument">
                            <b-modal
                                v-model="showDocument"
                                :hideFooter="true"
                                :title="uLang('app.document')"
                                size="lg"
                            >
                                <file-preview :url="route('action-documents.pdf.index', { action_document: this.id })" />
                            </b-modal>
                        </portal>

                        <table class="table">
                            <tr>
                                <td width="200">{{ uLang('app.name') }}:</td>
                                <td>{{ action_document.name }}</td>
                            </tr>
                            <tr>
                                <td width="200">{{ uLang('app.title') }}:</td>
                                <td>{{ action_document.title }}</td>
                            </tr>
                            <tr>
                                <td width="200">{{ uLang('app.is_the_title_displayed') }}:</td>
                                <td>{{ uLang('app.' + action_document.title_displayed) }}</td>
                            </tr>
                            <tr>
                                <td width="200">{{ uLang('app.template_category') }}:</td>
                                <td><b-badge pill variant="primary">{{ action_document.action_document_category.name }}</b-badge></td>
                            </tr>
                            <tr>
                                <td width="200">{{ uLang('app.needs_to_be_checked') }}:</td>
                                <td><b-badge pill variant="primary">{{ uLang('app.' + (action_document.needs_to_be_checked ? 'yes' : 'no')) }}</b-badge></td>
                            </tr>
                            <!-- concepts disabled
                            <tr>
                                <td width="200">{{ uLang('app.is_concept') }}:</td>
                                <td><b-badge pill variant="primary">{{ uLang('app.' + (action_document.is_concept ? 'yes' : 'no')) }}</b-badge></td>
                            </tr>
                            -->
                            <tr>
                                <td colspan="2">{{ uLang('app.template') }}:</td>
                            </tr>
                        </table>
                        <div class="ck-content">
                            <div class="action-document-template" v-html="action_document.template"></div>
                        </div>

                        <table class="table">
                            <tr>
                                <td width="200">{{ uLang('app.is_archived') }}:</td>
                                <td>{{ action_document.is_archived ? uLang('app.yes') : uLang('app.no') }}</td>
                            </tr>
                            <tr>
                                <td width="200">{{ uLang('app.service_according_to_blik_op_werk') }}:</td>
                                <td>{{ action_document.bilk_op_werk_category?.value ?? "-" }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'show',

        props: {
            id: {
                required: true,
            },
        },

        data: function () {
            return {
                action_document: null,
                showDocument: false
            }
        },

        created() {
            this.retrieveActionDocument();
        },

        methods: {
            async retrieveActionDocument(){
                const { data } = await window.axios.get(route('action-documents.show', { action_document: this.id }));
                this.action_document = data;
            },
        }
    }
</script>
<link rel="stylesheet" href="/css/content-styles.css" type="text/css">
